import type { UserInputValidationError } from '@tectonics/prs/validation';

const MIN_LENGTH = 3;
const MAX_LENGTH = 100;
// Indonesian names may contain apostrophes (Ma'ruf), hyphens (Nur-Aini) and
// periods (Dr.), and may not be padded with spaces.
const ID_NAME_PATTERN = /^[\p{L}](?:[\p{L} '.-]*[\p{L}'.-])?$/u;

export function validateIndonesianCustomerName(customerNameValue: string): UserInputValidationError | undefined {
  const customerName = customerNameValue || '';

  if (!customerName.trim()) {
    return { id: 'empty' };
  }

  if (customerName.length < MIN_LENGTH) {
    return { id: 'min-length' };
  }

  if (customerName.length > MAX_LENGTH) {
    return { id: 'max-length' };
  }

  if (!ID_NAME_PATTERN.test(customerName)) {
    return { id: 'invalid-characters' };
  }

  return undefined;
}
